var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "PrescriptionModal__container",
        attrs: { id: "rb-rox-measure-pupillary-distance" },
      },
      [
        _c(
          "div",
          { staticClass: "PrescriptionModal__container__closeContainer" },
          [
            _c("div", { staticClass: "PrescriptionModal__container__title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.translation(
                      "prescription_module.measure_distance.title"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("a", { staticClass: "PrescriptionModal__container__close" }, [
              _vm.isMobile
                ? _c("span", {
                    staticClass: "common__icon common__icon--close-bold",
                  })
                : _vm._e(),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "PrescriptionModal__container__infoModalBody" },
          [
            _c(
              "div",
              {
                staticClass: "PrescriptionModal__container__infoModalBodyElem",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "PrescriptionModal__container__infoModalBodyElem__desc",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.translation(
                            "prescription_module.measure_distance.pupillary_distance"
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "PrescriptionModal__container__infoModalBodyElem",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "PrescriptionModal__container__infoModalBodyElem__desc",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.translation(
                            "prescription_module.measure_distance.default_setting"
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "PrescriptionModal__container__infoModalBodyElem",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "PrescriptionModal__container__infoModalBodyElem__desc",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.translation(
                            "prescription_module.measure_distance.measure_pd"
                          )
                        ) +
                        "\n\n          "
                    ),
                    _c("ul", [
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.translation(
                              "prescription_module.measure_distance.grab"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.translation(
                              "prescription_module.measure_distance.position"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.translation(
                              "prescription_module.measure_distance.close"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          _vm._s(
                            _vm.translation(
                              "prescription_module.measure_distance.measure_distance"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.translation(
                                "prescription_module.measure_distance.number"
                              )
                            ) +
                            "\n            "
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }